module.exports = __webpack_public_path__ + "img/_54A2230_t.8975a33d.jpg";